// src/i18n/gateMessages.js
// Single source of truth for resolving auth-gate reassurance copy.
//
// An auth-gated action (Follow, comment, create event, …) passes a `message`
// that is EITHER one of the action-specific gate KEYS below (resolved via the
// `auth` translation namespace) OR a literal string (shown verbatim, for the
// few callers that pass ready-made copy). An empty/unknown value falls back to
// the generic gate copy.
//
// This lives in one place on purpose: the merged login modal (and any other
// surface that reassures before taking credentials) must resolve the same keys
// the same way — resolving them in two components would seed exactly the drift
// the librarian standards exist to prevent.

export const GATE_BODY_KEYS = new Set([
  'gate_body_join_group',
  'gate_body_create_group',
  'gate_body_post',
  'gate_body_comment',
  'gate_body_add_event',
  'gate_body_create_chat',
  'gate_body_suggest_listing',
  'gate_body_generic'
]);

// Resolve a gate `message` to display copy.
// `t` must be a translator bound to the `auth` namespace (useTranslation('auth')).
export const resolveGateMessage = (message, t) => {
  if (GATE_BODY_KEYS.has(message)) return t(message);
  if (typeof message === 'string' && message.trim().length > 0) return message;
  return t('gate_body_generic');
};
